import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { BadgeModule } from 'primeng/badge';
import { MenuModule } from 'primeng/menu';
import { MenuItem } from 'primeng/api';
import { AuthService } from '../../services/auth.service';
import { ChangePasswordDialogComponent } from '../../dialogs/change-password-dialog/change-password-dialog.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BreakpointObserver } from '@angular/cdk/layout';
import { DrawerModule } from 'primeng/drawer';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-navbar',
  imports: [
    AvatarGroupModule,
    AvatarModule,
    BadgeModule,
    ButtonModule,
    DrawerModule,
    MenuModule,
    RouterLink,
    TranslatePipe,
  ],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent implements OnInit {
  public changePasswordRef: DynamicDialogRef | undefined | null;
  public isMobile: boolean = false;
  public items: MenuItem[] = [];
  public itemsAdmin: MenuItem[] = [];
  public roles: string[] = [];
  public showDrawer: boolean = false;

  constructor(
    public authService: AuthService,
    private breakpointObserver: BreakpointObserver,
    private dialogService: DialogService,
    private router: Router,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.roles = this.authService.getTokenFieldValue('roles');
    this.buildMenu();
    this.translate.onLangChange
      .subscribe(() => {
        this.buildMenu();
      });

    this.breakpointObserver
      .observe(['(max-width: 768px)'])
      .subscribe(result => {
        this.isMobile = result.matches;
      });
  }

  private buildMenu(): void {
    this.items = [
      {
        label: this.authService.getTokenFieldValue('name'),
        items: [
          {
            label: this.translate.instant('button.edit-user'),
            icon: 'pi pi-cog',
            disabled: true,
          },
          {
            label: this.translate.instant('button.change-password'),
            icon: 'pi pi-lock',
            disabled: false,
            command: () => {
              this.showDrawer = false;
              this.changePassword()
            }
          },
          {
            label: this.translate.instant('button.logout'),
            icon: 'pi pi-sign-out',
            command: () => {
              this.showDrawer = false;
              this.authService.logout()
            }
          }
        ]
      }
    ];

    this.itemsAdmin = [
      {
        label: this.translate.instant('menu.users'),
        icon: 'pi pi-user',
        command: () => {
          this.showDrawer = false;
          this.router.navigate(['/admin/users']);
        }
      }
    ]
  }

  private changePassword(): void {
    this.changePasswordRef = this.dialogService.open(ChangePasswordDialogComponent, {
      header: this.translate.instant('title.password-change'),
      closable: true,
    });
  }
}
